import React, { useState, useEffect } from "react";
import { Button, Form, InputGroup, Modal, Alert } from "react-bootstrap";

import _ from "underscore";

const axios = require("axios");
// const pk = "9lsoo3-4924-4kkkka-llikh2";
// const store = require("store");
// const jwt = require("jsonwebtoken");
const EmailVerificationMdl = ({
  props,
  show,
  setEmailMdlShow,
  setLoginShow,
  setErrorShow,
  setErrors,
  want_url = "/Home",
}) => {
  const [usernameverify, setUsernameVerify] = useState("");
  const [hasSuccess, sethasSuccess] = useState("");

  want_url = want_url || "/Home";
  // console.log(want_url);
  const handleEmailVerification = (event) => {
    axios
      .post(
        !_.isUndefined(process.env.REACT_APP_API_URL)
          ? process.env.REACT_APP_API_URL + "/Auth/emailVerification"
          : "/Auth/emailVerification",
        {
          username: usernameverify,
          credentials: "include",
        },
        { withCredentials: true }
      )

      .then((res) => {
        if (res) {
          if (!_.isUndefined(res.status) && res.status === 200) {
            setLoginShow(false);
            // window.location.href = want_url; //"/Home";
            sethasSuccess(true);
          } else {
            //todo setError;
            sethasSuccess(false);
            setErrors({ message: "Invalid Email" });
            setErrorShow(true);
          }
        } else {
          // const error = new Error(res.error);
          setErrors({ message: "Invalid Email Address" });
          setErrorShow(true);
          sethasSuccess(false);
        }
        //callback for the response
      })
      .catch((error) => {
        setErrors({ message: "Invalid Email" });
        setErrorShow(true);
      });

    event.preventDefault();
  };
  //   useEffect(() => {
  //     document.title = "Trip Medical Database";
  //     // document.body.classList.remove("homepage");
  //   }, []);
  return (
    <>
      <Modal
        // size="lg"
        show={show}
        onHide={(e) => setEmailMdlShow(false)}
        onShow={(e) => {
          // setUsernameVerify("");
          // sethasSuccess(false);
          //   let el = document.getElementById("login-mdl");
          //   if (el) el.classList.add("modal-dialog--login");
        }}
        animation={false}
        centered
      >
        <Modal.Header closeButton>
          {/* <div className="logo"> */}
          We've introduced email verification
          {/* </div> */}
        </Modal.Header>
        <Modal.Body>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={(e) => setEmailMdlShow(false)}
          >
            <span aria-hidden="true">×</span>
          </button>
          {/* <h2 className="modal-title" id="loginModalLabel">
            Verify Email!
          </h2> */}
          <Form onSubmit={handleEmailVerification}>
            {/* <Form.Group controlId="Username">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="prepend-email">
                    <i className="fa fa-envelope"></i> Email:
                  </InputGroup.Text>
                </InputGroup.Prepend>

                <Form.Control
                  type="email"
                  name="Username"
                  placeholder="Enter email"
                  value={usernameverify}
                  onChange={(e) => setUsernameVerify(e.target.value)}
                  required
                />
              </InputGroup>
            </Form.Group> */}
            {/* {hasSuccess ? ( */}
            <Alert variant="warning pull-left">
              {/* <div>Email sent!</div> */}
              <p>
                Since you registered, we've added an email verification step.
                We've just sent you a message — please click the verification
                link to confirm your account. If you don't see the email in your
                inbox within a few minutes, check your spam or junk folder.
                Still need help?{" "}
                <a href="mailto:jon.brassey@tripdatabase.com">
                  Contact our support team
                </a>{" "}
                and we'll assist you.
              </p>
            </Alert>
            {/* ) : (
              ""
            )} */}
            <Modal.Footer>
              <Button
                className="btn btn-primary btn-lg pull-right"
                type="button"
                onClick={(e) => setEmailMdlShow(false)}
              >
                <i className="fa fa-times"></i> Close
              </Button>
            </Modal.Footer>
          </Form>
          <hr></hr>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EmailVerificationMdl;
